/*
 * Registers the Font Awesome solid pack with the global icon library.
 *
 * Import this from a component that renders <font-awesome-icon>, never from
 * createApp.js. createApp is shared by all ten entry bundles, so registering the
 * pack there put 1,012 KB of source into vendor.js — 27% of it — on every page,
 * for the two components that actually use icons.
 *
 * The whole pack is loaded rather than named icons because the icon names arrive
 * at runtime from the API (`facility.icon`), so they are not known at build time.
 * Both consumers are async-imported components, so this lands in their chunk and
 * is fetched only when a school detail page is opened.
 */

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fas)
